import React from "react";
import { CredentialLayout } from "../CredentialLayout";
import { CredentialEntities } from "../CredentialEntities";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { CredentialProps } from "../CredentialProps";

interface AWSViewPageProps extends NSARouterMakerResult, CredentialProps { }

class AWSViewPage extends React.Component<AWSViewPageProps>
{
	override render()
	{
		return (
			<CredentialLayout
				{...this.props}
				action={{
					description: "This section shows the full details of an Amazon Web Services (AWS) credential, including its name and the access key and secret key it stores as secrets. You can review its history and tags and copy any field, while the secret values stay protected."
				}}
				pages={{
					entity: CredentialEntities.aws(this.props),
					view: {}
				}}
			>
				<></>
			</CredentialLayout>
		);
	}
}

export default AWSViewPage;